import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SideNaveData } from '@klickdata/core/mobile';
import { SideNaveActionsTypes, SideNaveResponseData } from '@klickdata/core/mobile/src/mobile.service';
import { Resource, ResourceService } from '@klickdata/core/resource';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { takeUntil } from 'rxjs';
import { Observable } from 'rxjs';
import * as moment from 'moment';
@Component({
    selector: 'app-menu-side-update-resource-item',
    templateUrl: './menu-side-update-resource-item.component.html',
    styleUrls: ['./menu-side-update-resource-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideUpdateResourceItemComponent implements OnInit {
    @Input() navData: SideNaveData;
    @Output() onClose: EventEmitter<SideNaveResponseData> = new EventEmitter();
    SideNaveActionsTypes = SideNaveActionsTypes;
    public resource$: Observable<Resource>;
    constructor(private resourceService: ResourceService) {}
    ngOnInit(): void {
        this.resource$ = this.resourceService.getResource(+this.navData.data.resId);
    }
    compareVersion(updatedAt: string, originalUpdatedAt: string) {
        return moment(updatedAt).isAfter(originalUpdatedAt)
            ? $localize`This version has the latest changes`
            : $localize`Original version has the latest changes`;
    }
}
